import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { ResponseCommentTemplate } from '@/schema/commentTemplate'

interface CommentTemplateStore {
  // State
  searchQuery: string
  editingTemplate: ResponseCommentTemplate | null
  dialogOpen: boolean
  deletingTemplate: ResponseCommentTemplate | null
  deleteDialogOpen: boolean

  // Actions
  setSearchQuery: (query: string) => void
  setEditingTemplate: (template: ResponseCommentTemplate | null) => void
  setDialogOpen: (open: boolean) => void
  setDeletingTemplate: (template: ResponseCommentTemplate | null) => void
  setDeleteDialogOpen: (open: boolean) => void
  reset: () => void
}

const initialState = {
  searchQuery: '',
  editingTemplate: null as ResponseCommentTemplate | null,
  dialogOpen: false,
  deletingTemplate: null as ResponseCommentTemplate | null,
  deleteDialogOpen: false,
}

export const useCommentTemplateStore = create<CommentTemplateStore>()(
  devtools(
    (set) => ({
      ...initialState,

      setSearchQuery: (query: string) => {
        set({ searchQuery: query }, false, 'setSearchQuery')
      },

      setEditingTemplate: (template: ResponseCommentTemplate | null) => {
        set(
          { editingTemplate: template, dialogOpen: !!template },
          false,
          'setEditingTemplate'
        )
      },

      setDialogOpen: (open: boolean) => {
        set({ dialogOpen: open }, false, 'setDialogOpen')
      },

      setDeletingTemplate: (template: ResponseCommentTemplate | null) => {
        set(
          { deletingTemplate: template, deleteDialogOpen: !!template },
          false,
          'setDeletingTemplate'
        )
      },

      setDeleteDialogOpen: (open: boolean) => {
        set({ deleteDialogOpen: open }, false, 'setDeleteDialogOpen')
      },

      reset: () => {
        set(initialState, false, 'reset')
      },
    }),
    { name: 'CommentTemplateStore' }
  )
)
